module.exports = __webpack_public_path__ + "assets/login-frontend/id_cutaway-150651c8f46a4b7c.png";